//React、hooks
import React, { useEffect, useState } from "react";
//css
import "../../css/Login.css";

import { useSelector } from "react-redux";
import { useDispatch } from "../../redux/hooks";
import {
  userEmail,
  errorMsg,
  loginJudge,
  fetchAsyncLogin,
  loading,
  editEmail,
  setError,
} from "./LoginSlice";
import { useHistory } from "react-router-dom";

const Login: React.FC = () => {
  const userEmailValue = useSelector(userEmail);

  //コンポーネント内でのみ管理
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  //エラーメッセージ
  const errorMessage = useSelector(errorMsg);
  //ログイン成功判定
  const loginJudgement = useSelector(loginJudge);
  //ローディング中
  const loadingJudgement = useSelector(loading);
  //reducerにアクセス
  const dispatch = useDispatch();
  //リダイレクト用
  const navigate = useHistory();

  //ログイン成功？
  useEffect(() => {
    if (loginJudgement) {
      sessionStorage.setItem("user_id", userEmailValue);
      navigate.push("/");
    }
  }, [loginJudgement, navigate]);

  //メアド & パスワード編集関数
  const editEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    if (errorMessage) {
      dispatch(setError(""));
    }
  };

  const editPassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
    if (errorMessage) {
      dispatch(setError(""));
    }
  };

  //ログインフォーム送信関数
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email && password.length >= 8 && errorMessage === "") {
      dispatch(fetchAsyncLogin({ email: email, password: password }));
    } else if (password && password.length < 8) {
      //passwordの文字数validation.
      dispatch(setError("passwordは8文字以上です。"));
    } else if (email && password.length >= 8 && errorMessage !== "") {
      //前回のエラーから変更していない
      return;
    } else {
      //email,passwordのvalidation.
      dispatch(setError("emailとpasswordは必須項目です。"));
    }
  };

  return (
    <>
      <div className="login_container">
        <form className="login_form">
          <div className="login_title_container">
            <h1 className="login_title">Su__i 管理者画面　ログイン</h1>
          </div>
          <div className="login_input_container">
            {errorMessage && <div className="error_msg">{errorMessage}</div>}
            {loadingJudgement && <div className="error_msg">認証中です...</div>}
            <input
              className="login_id_item"
              type="text"
              required
              placeholder="email"
              name="email"
              value={email}
              onChange={editEmail}
            />
            <input
              className="login_password_item"
              type="password"
              required
              placeholder="password"
              name="password"
              value={password}
              onChange={editPassword}
            />
          </div>
          <div className="login_submit_button_container">
            <button className="login_submit_button" onClick={handleSubmit}>
              Login
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Login;
